import { render, staticRenderFns } from "./ActiveService.vue?vue&type=template&id=b1657c44"
import script from "./ActiveService.vue?vue&type=script&lang=js"
export * from "./ActiveService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports